<div class="panel" [class.animate]="isReady()" [class.collapsed]="!isExpanded()">
  <div class="minimap-canvas">
    <ng-diagram-minimap [deferNodeUpdates]="deferNodeUpdates()" [showZoomControls]="false" />
  </div>
  <div class="minimap-actions">
    <div class="zoom-buttons">
      <button
        class="action-button"
        aria-label="Zoom out"
        mat-icon-button
        [disabled]="!canZoomOut()"
        (click)="zoomOut()"
      >
        <mat-icon>remove</mat-icon>
      </button>
      <button class="action-button" aria-label="Zoom in" mat-icon-button [disabled]="!canZoomIn()" (click)="zoomIn()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <span class="zoom-level">{{ zoomPercent() }}</span>
    <button
      class="action-button"
      aria-label="Keyboard shortcuts"
      mat-icon-button
      matTooltipClass="keyboard-shortcuts-tooltip"
      matTooltipPosition="left"
      [matTooltip]="keyboardShortcutsTooltip"
    >
      <mat-icon>info_outline</mat-icon>
    </button>
    <button class="action-button" aria-label="Toggle minimap" mat-icon-button (click)="toggleExpanded()">
      <mat-icon>map</mat-icon>
    </button>
  </div>
</div>
